module.exports = {
    ageGroups: ['Preschool', 'Elementary', 'Middle School', 'High School', 'Tertiary Education', 'Professional education', 'All education levels'],
    platforms: ['Desktop Windows', 'Desktop Mac', 'Mobile Android', 'Mobile iOS', 'Other', 'Non-digital product', 'Browser-based'],
    purchaseModels: [
        'One time purchase',
        'Free',
        'Subscription',
        'Free with subscription',
        'Free with in-app-purchases',
        'Paid with in-app-purchases'
    ],
    pedagogicalApproachParameters: [
        { name: "Passive - Active", index: 1 },
        { name: "Rehearse - Construct", index: 2 },
        { name: "Linear - Non-linear/Creative", index: 3 },
        { name: "Individual - Collaborative", index: 4 }, //This might seem weird but it's used to mimic backend representation of this and ensure easier sync
    ]
};



// WEBPACK FOOTER //
// ./src/app/utils/defaultsProvider.js